import ChartBase from './chart-base.component';
export default ChartBase;
